import HeaderBar from '../components/bar/head-bar.vue'
import AddBase from '../components/add/base.vue'
import AddAg from '../components/add/ag.vue'
import FilterSpan from '../components/filterSpan/filterSpan.vue'

import { formPromise } from '../util/index.js'

export default {
    install(Vue){
        Vue.component('head-bar', HeaderBar)
        Vue.component('add-base', AddBase)
        Vue.component('add-ag', AddAg)
        Vue.component('filter-span', FilterSpan)

        Vue.prototype.$validate = formPromise
        Vue.prototype.$number = function(value){
            const reg = new RegExp("^[0-9]*$")
            return !reg.test(value)
        }
    }
}


// WEBPACK FOOTER //
// ./src/plugins/index.js